import React from 'react';
import { Modal, Form } from 'react-bootstrap';
import moment from 'moment';
import ExpandingTextArea from 'react-expanding-textarea';

// Services & Helpers
import GlobalStateService from 'services/GlobalStateService';
import InstructorService from 'services/InstructorService';

// Components
import Loader from 'components/common/Loader';

//-------------------------------------------------------------------------------------------------------------------

class SubmitAvailabilityModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        };
    }

    show(opts) {
        return new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.setState({
                isSuccess: false,
                slug: opts.slug,
                datesAdded: opts.datesAdded,
                datesRemoved: opts.datesRemoved,
                removeDatesReason: null,
                isOpen: true,
                notes: ''
            });
        });
    }

    close() {
        clearInterval(this.autoCloseInterval);
        this.setState({
            isOpen: false
        });
    }

    componentWillUnmount() {
        clearInterval(this.autoCloseInterval);
    }

    async confirm() {
        this.setState({
            isLoading: true
        });
        await InstructorService.updateAvailability(
            this.state.slug,
            this.state.datesAdded.map(d => d.date),
            this.state.datesRemoved.map(d => d.date),
            this.state.notes,
            this.state.removeDatesReason
        );
        this.setState({
            isLoading: false,
            isSuccess: true,
            autoCloseTime: 20
        }, () => {
            this.resolve();
            this.startAutoCloseInterval();
        });
    }

    startAutoCloseInterval() {
        this.autoCloseInterval = setInterval(() => {
            this.setState({
                autoCloseTime: this.state.autoCloseTime - 1
            }, () => {
                if (this.state.autoCloseTime == 0) {
                    this.close();
                }
            });
        }, 1000);
    }

    //------------------------------------------------------------------------------

    render() {
        const {
            isOpen
        } = this.state;

        if (!isOpen) {
            return null;
        }

        return (
            <Modal show className="submit-availability-modal">
                {this.renderInner()}
            </Modal>
        );
    }

    renderInner() {
        const {
            isLoading,
            slug,
            isSuccess,
            autoCloseTime,
            notes,
            removeDatesReason
        } = this.state;
        const datesAdded = this.state.datesAdded.filter(da => !da.isLocked);
        const datesRemoved = this.state.datesRemoved.filter(da => !da.isLocked);
        const datesRemovedRequiresApproval = this.state.datesRemoved.filter(da => da.isLocked);

        if (isLoading) {
            return (
                <Modal.Body>
                    <Loader />
                </Modal.Body>
            );
        }

        if (isSuccess) {
            return (
                <Modal.Body>
                    {(datesAdded.length > 0 || datesRemoved.length > 0) && <>
                        Thank you, your updates have been submitted.
                        <br />
                    </>}
                    
                    {datesRemovedRequiresApproval.length > 0 && <>
                        {datesRemovedRequiresApproval.length}{' '}
                        date{datesRemovedRequiresApproval.length == 1 ? ' requires approval before it' : 's require approval before they'}
                        {' '}will be submitted.
                        <br />
                        You will be notified by a member of the team.
                    </>}

                    <div>

                        <button className="btn btn-primary btn-block mt-3" onClick={e => this.close()}>
                            Close ({autoCloseTime})
                        </button>

                    </div>

                </Modal.Body>
            );
        }

        const loginInfo = GlobalStateService.getValue('loginInfo');

        return (<>
            <Modal.Body>

                <p>Are you sure you wish to submit these updates?</p>
                
                {datesAdded.length > 0 && <>
                    <p>
                        <b>Dates added:</b>
                    </p>
                    <ul>
                        {datesAdded.map(d =>
                            <li key={d}>
                                {moment(d.date).format('dddd, DD MMMM YYYY')}
                            </li>
                        )}
                    </ul>
                </>}

                {datesRemoved.length > 0 && <>
                    <p>
                        <b>Dates removed:</b>
                    </p>
                    <ul>
                        {datesRemoved.map(d =>
                            <li key={d}>
                                {moment(d.date).format('dddd, DD MMMM YYYY')}
                            </li>
                        )}
                    </ul>
                </>}

                {datesRemovedRequiresApproval.length > 0 && <>
                    <div className="text-bad mb-3">
                        {datesRemovedRequiresApproval.length > 0 && <>
                            <p>
                                <b>
                                    You have requested to remove the below dates which are reserved with the vendor.
                                    Please wait for our confirmation before taking further action:
                                </b>
                            </p>
                            <ul>
                                {datesRemovedRequiresApproval.map(d =>
                                    <li key={d}>
                                        {moment(d.date).format('dddd, DD MMMM YYYY')}
                                    </li>
                                )}
                            </ul>
                        </>}
                    </div>

                    <Form.Group className="mb-3">
                        <Form.Label>Why do you need to remove these dates?</Form.Label>
                        <select
                            className="form-control"
                            value={removeDatesReason}
                            onChange={e => this.setState({ removeDatesReason: e.target.value })}
                        >
                            <option value="">(Please select)</option>
                            <option value="Vacation">I'm taking a vacation</option>
                            <option value="AnotherBooking">I'm taking another booking</option>
                            <option value="PersonalMatter">A personal matter</option>
                            <option value="Mistake">Date added by mistake</option>
                            <option value="Other">Something else</option>
                        </select>
                    </Form.Group>

                </>}

                {loginInfo.isAdmin &&
                    <Form.Group>
                        <Form.Label>Notes (admin only)</Form.Label>
                        <ExpandingTextArea
                            className="form-control"
                            value={notes || ''}
                            rows={3}
                            onChange={e => this.setState({ notes: e.target.value })}
                        />
                    </Form.Group>
                }

            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-secondary me-auto" onClick={() => this.close()}>
                    No
                </button>
                <button type="submit" className="btn btn-primary ms-auto" onClick={e => this.confirm()}>
                    Yes
                </button>
            </Modal.Footer>
        </>);
    }
}

export default SubmitAvailabilityModal;